import { createFileRoute } from "@tanstack/react-router"

import { MarketingReportingRunPage } from "@/pages/marketing-reporting-run"

export const Route = createFileRoute("/(marketing)/marketing/reporting/$runId")(
	{
		staticData: {
			breadcrumbKey: "navigation.breadcrumbs.runDetail",
		},
		component: function MarketingReportingRunRoute() {
			const { runId } = Route.useParams()
			return <MarketingReportingRunPage runId={runId} />
		},
	},
)
